import { useContext } from 'react';
import storesContext from './contexts';

const useStores = (auctionID = null) => {
    const stores = useContext(storesContext);

    // If no auctionID is provided, return all stores including the multi-auction store
    if (!auctionID) {
        return stores;
    }

    // Get the specific AuctionStore and BidStore from MultiAuctionStore using auctionID
    const { MultiAuctionStore } = stores;
    const AuctionStore = MultiAuctionStore.getAuction(auctionID);
    const BidStore = MultiAuctionStore.getBidStore(auctionID);
    const MessageStore = MultiAuctionStore.getMessageStore(auctionID);

    return {
        ...stores,
        AuctionStore,
        BidStore,
        MessageStore,
    };
};

export default useStores;
